import { render, staticRenderFns } from "./payPurchaseCheque.vue?vue&type=template&id=08273f52"
import script from "./payPurchaseCheque.vue?vue&type=script&lang=js"
export * from "./payPurchaseCheque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports